<template>
  <el-header class="top-bar">
    <div class="logo">
      <!-- Logo和标题 -->
<!--      <el-avatar size="default" icon="el-icon-user" />-->
<!--      <span class="title">TLS</span>-->
    </div>
    <div class="user-info">
      <!-- 用户信息 -->
      <el-avatar size="default" icon="el-icon-user-solid" :src="stateUserAvatar"/>
    </div>
  </el-header>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'TopBar',
  data() {
    return {
      stateUserAvatar: ""
    }
  },

  computed: {
    ...mapState(['userAvatar']),
  },

  watch: {
    userAvatar(newValue) {
      this.stateUserAvatar = this.$store.state.userAvatar;
    },
  },

  mounted() {

  }
};
</script>

<style scoped>
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  padding: 0 20px;
  color: #333;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
  height: 50px; /* 设置顶部栏高度 */
}

.logo {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
}

.title {
  font-size: 22px;
  font-weight: bold;
  margin-left: 10px;
  line-height: 60px; /* 与父容器顶部栏高度一致，垂直居中 */
}

.user-info {
  display: flex;
  align-items: center;
}
</style>
